<template>
    <div>
        <app-sub-title :text="`Sedes cliente ${client.name}`"/>
        <b-button variant="primary" @click="startSaveVenue" class="btn-block-xs-only"><i class="fa fa-plus"></i> Crear Sede</b-button>
        <app-venue-list
            :data="data"
            @change-page="changePage"
            @update-venue="startUpdate"
            @remove-venue="startRemove"
            @sort="onSort"
        />
        <!-- inicio de pop up's -->
        <app-pop-up title="Confirmación" id="venue-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar esta sede?</h2></div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteVenue(selectVenue)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>
        </app-pop-up>

        <app-pop-up title="Formulario de sede" id="venue-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <app-venue-form :the-client="theClient"
                    :my-venue="selectVenue" :onSave="onSave"
                />
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" :disabled="inProgress" @click="$bus.$emit('venue-form.save')"> Guardar</button>
            </div>
        </app-pop-up>

        <!-- fin de pop up's -->
    </div>
</template>

<script>
import VenueForm from './VenueForm/VenueForm.vue';
import VenueList from './VenueList/VenueList.vue';
import venuesRepository from '../../../repositories/venues.repository.js';
export default {
    props: {
        theClient: {
            required: true
        }
    },
    components: {
        appVenueForm: VenueForm,
        appVenueList: VenueList
    },
    data(){
        return {
            data: {},
            page: 1,
            selectVenue: '',
            filters: {},
            sort: {
                sortBy: 'name',
                sortDir: 'asc'
            }
        }
    },
    methods: {
        loadVenues(){
            const vr = {...venuesRepository};
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
            vr.loadVenuesByClient(this.theClient.id, filters, this.page)
            .then(data => {
                this.data = data;
            })
            .catch(error => {
                toastr.error('Error al cargar las sedes del cliente');
            });
        },
        changePage(page){
            this.page = page;
            this.loadVenues();
        },
        startSaveVenue(){
            this.selectVenue = '';
            this.$bus.$emit('venue-form.open');
        },
        onSave() {
            this.$bus.$emit('venue-form.close');
            this.loadVenues();
        },
        cleanForm() {
            this.$bus.$emit('venue-form.clean');
        },
        startUpdate(venue){
            this.selectVenue = Object.assign({}, venue);
            this.$bus.$emit('venue-form.open'); 
        },
        startRemove(venue){
            this.selectVenue = venue;
            this.$bus.$emit('venue-remove.open');
        },
        deleteVenue(venue) {
            const vr = {...venuesRepository};
            vr
                .deleteVenue(venue.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadVenues();
                        this.$bus.$emit('venue-remove.close');
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el usuario');
                });
        },
        initialize(){
            this.loadVenues();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadVenues();
        }
    },
    created(){
        this.initialize();
    }
}
</script>

<style>

</style>
